<template>
  <div v-if="item.game_id">
    <div v-if="yuyueFlag" class="yuyue">
      <single-button class="yubtn game-start" v-if="!item.is_reservation" :antishake="false" @know="toYuyue" text="预约" :width="width" :height="height" color="#FFDB89"></single-button>
      <single-button class="game-start" v-else :antishake="false" text="已预约" @know="cyuyue" :width="width" :height="height" background="#FFEEC8" color="#855200"></single-button>
    </div>
    <div v-else>
      <van-button :class="['game-start',starttext == '敬请期待' && 'bg_none']" @click.stop="startGame" :style="btnStyle()">{{starttext}}</van-button>
    </div>

    <div @click.stop="">
      <van-popup v-model="showQRCodePopup" class="qrcode-popup" :get-container="'#app'">
        <div @click.stop="" class="qrcode-container">
          <div class="qrcode-box">
            <qrcode-vue :value="downloadUrl" :size="130" level="M" :margin="0" render-as="svg"></qrcode-vue>
          </div>
          <div class="download-buttons">
            <div class="android-download" @click="downloadAndroid" style="margin-bottom: 17px;">
              <img src="@/assets/image/h5img/andown.png" alt="安卓" class="platform-icon" />
            </div>
            <div class="ios-download" @click="downloadIOS">
              <img src="@/assets/image/h5img/iosdown.png" alt="iOS" class="platform-icon" />
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import { baseURL } from '@/ajax';

export default {
  components: {
    QrcodeVue
  },
  props: {
    width: {
      type: String,
      default: '3rem'
    },
    height: {
      type: String,
      default: '1.5rem'
    },
    item: {
      default: () => ({})
    },
    background: {
      type: String,
      default: 'linear-gradient(87deg, #1d1d1d 0%, #5b4e3f 100%)'
    },
    color: {
      type: String,
      default: '#FFDB89'
    }
  },
  computed: {
    isIOS() {
      return this.$device().isIOS
    },
    isAndroid() {
      return this.$device().isAndroid
    },
    yuyueFlag() {
      switch (this.isIOS) {
        case false:
          if (this.item.subscribe_state == 1 && !this.item.android_download_url) {
            return true
          }
          break;
        case true:
          if (this.item.subscribe_state == 1 && !this.item.ios_download_url) {
            return true
          }
          break;
      }
    },
    downloadUrl() {
      return baseURL + '/common/gameDownload?game_id=' + this.item.game_id
    },
    isNoUrl(){
      return !this.item.android_download_url && !this.item.ios_download_url
    },
    starttext() {
      if(this.item.wxmini_game_appid) return '启动'
      if(this.isNoUrl || (this.isAndroid && !this.item.android_download_url && this.subscribe_state != 1) || (this.isIOS && !this.item.ios_download_url && this.subscribe_state != 1) ){
        if(this.$route.path == '/pages/index/gamedetail/gamedetail'){
          return '敬请期待'
        }
        return '详情'
      }
      return '启动'
    }
  },
  data() {
    return {
      gameFlag: true,
      showQRCodePopup: false
    }
  },

  methods: {
    // 取消预约
    cancelYuyue() {
      this.$ajax('/game/cancelReservationGame', {
        game_id: this.item.game_id
      }).then(rs => {
        if (rs.code == 200) {
          this.$toast('取消预约成功')
          this.$set(this.item, 'is_reservation', false)
          this.$store.commit('setGameis_reservation', {
            game_id: this.item.game_id,
            is_reservation: false
          })
        } else {
          this.$toast(rs.msg)
        }
      })
    },
    cyuyue() {
      const phone = this.$store.state.user.info.bindPhone
      // 将手机号中间4位替换成****
      const reg = /^(\d{3})\d{4}(\d{4})$/
      const newPhone = phone.replace(reg, '$1****$2')
      this.$store.commit('popup/setisMobileCofirm', {
        yuyue: true,
        yuyueFunc: this.cancelYuyue,
        phone: newPhone
      })
    },
    toYuyue() {
      this.$ajax('/game/reservationGame', {
        game_id: this.item.game_id
      }).then(rs => {
        if (rs.code == 200) {
          this.$toast('预约成功')
          this.$set(this.item, 'is_reservation', true)
          this.$store.commit('setGameis_reservation', {
            game_id: this.item.game_id,
            is_reservation: true
          })
        } else {
          this.$toast(rs.msg)
        }
      })
    },
    startGame() {
      if(this.item.wxmini_game_appid) return location.href = this.item.wxmini_game_appid
      if(this.isNoUrl || this.starttext == '详情'){
        this.$router.push('/pages/index/gamedetail/gamedetail?id=' + this.item.game_id)
        return
      }
      // 显示二维码弹窗
      if (this.$device().isPC) {
        this.showQRCodePopup = true
      } else {
        if (this.$device().isIOS) {
          window.open(this.item.ios_download_url)
        } else {
          this.downloadAndroid()
        }
      }

    },
    downloadAndroid() {
      if(!this.item.android_download_url) return this.$toast('敬请期待')
      location.href = this.item.android_download_url
    },
    downloadIOS() {
      if(!this.item.ios_download_url) return this.$toast('敬请期待')
      if(navigator.userAgent.indexOf('Mac') == -1) return this.$toast('仅限苹果下载')
      window.open(this.item.ios_download_url)
    },
    btnStyle() {
      return {
        width: this.width,
        height: this.height,
        background: this.background,
        color: this.color
      }
    }
  },

  watch:{
    '$store.state.user.gameis_reservation':{
      handler(val){
        if(val.length>0){
          val.forEach(item=>{
            if(item.game_id == this.item.game_id){
              this.$set(this.item,'is_reservation',item.is_reservation)
            }
          })
        }
      },
      deep: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.van-button {
  width: 3rem;
  height: 1.5rem;
  border: none;
  font-size: 0.7rem;
  background: linear-gradient(87deg, #1d1d1d 0%, #5b4e3f 100%);
  border-radius: 1.75rem;
  color: #ffdb89;
  white-space: nowrap;
}

.qrcode-popup {
  width: 433px;
  height: 179px;
  background: linear-gradient(180deg, #fff3d4 0%, #ffffff 100%);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #707070;
}

.qrcode-container {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
}

.qrcode-box {
  background-color: #ffffff;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
}

.download-buttons {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  img {
    width: 220px;
    height: 58px;
    display: block;
    &::nth-child(1) {
      display: block;
    }
  }
}

.platform-icon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.3rem;
}

.bg_none{
  background: #8E8E8E !important;
  color: #fff !important;
}
</style>